import React, { useState } from 'react';
import { apiFetch } from '../../utils/api';

function CreateGroupModal({ isOpen, onClose, users, currentUser, onSuccess }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('trip'); // 'trip' or 'daily'
  const [selectedMembers, setSelectedMembers] = useState([currentUser.id]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const toggleMember = (userId) => {
    if (userId === currentUser.id) return; // Creator must be in the group
    if (selectedMembers.includes(userId)) {
      setSelectedMembers(selectedMembers.filter((id) => id !== userId));
    } else {
      setSelectedMembers([...selectedMembers, userId]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Group name is required.');
      return;
    }

    setLoading(true);
    try {
      const res = await apiFetch('/groups', {
        method: 'POST',
        body: JSON.stringify({
          name: name.trim(),
          description: description.trim(),
          type,
          memberUserIds: selectedMembers,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to create group');
      }

      onSuccess();
      onClose();
    } catch (err) {
      setError(err.message || 'Error creating group.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content animate-slide-up">
        <div className="modal-header">
          <h3>📂 Create New Group</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Group Name</label>
            <input
              type="text"
              placeholder="e.g. EuroTrip 2026, Roommates"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <input
              type="text"
              placeholder="What is this group for?"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Group Type</label>
            <select value={type} onChange={(e) => setType(e.target.value)}>
              <option value="trip">🧳 Trip (Temporary expenses)</option>
              <option value="daily">📅 Daily (Recurring expenses)</option>
            </select>
          </div>

          <div className="form-group participants-scroll">
            <label>Select Members</label>
            <div className="participants-checklist">
              {users.map((u) => {
                const isCreator = u.id === currentUser.id;
                const isChecked = selectedMembers.includes(u.id);
                return (
                  <div key={u.id} className="participant-check-row">
                    <div className="check-label" onClick={() => toggleMember(u.id)}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        disabled={isCreator}
                        readOnly
                      />
                      <span>{isCreator ? `${u.name} (You)` : u.name}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateGroupModal;
